import Chart from "react-apexcharts";
import { PortfolioIncomeHistoryDto } from "@/models";

interface IProps {
  history: PortfolioIncomeHistoryDto;
}

// Project brand colors already used elsewhere (BTC gradient in
// pages/cabinet/statistic/index.module.scss, primary blue in
// styles/index.scss) - reused here instead of inventing a new palette.
const COIN_COLORS: Record<string, string> = {
  BTC: "#f7931a",
  ZEC: "#3a83f1",
};
const FALLBACK_COLORS = ["#0ac18f", "#e05656", "#8e6ce0"];

export function IncomeByCoinChart({ history }: IProps) {
  const colors = history.series.map(
    (s, idx) => COIN_COLORS[s.currency] || FALLBACK_COLORS[idx % FALLBACK_COLORS.length],
  );

  return (
    <Chart
      type="area"
      height={300}
      series={history.series.map((s) => ({ name: s.currency, data: s.data }))}
      options={{
        chart: { type: "area", stacked: true, toolbar: { show: false } },
        colors,
        dataLabels: { enabled: false },
        stroke: { curve: "smooth", width: 2 },
        fill: { type: "solid", opacity: 0.35 },
        xaxis: {
          type: "datetime",
          categories: history.days,
          labels: { datetimeFormatter: { day: "dd MMM" } },
        },
        yaxis: {
          labels: {
            formatter: (val: number) => `${Math.round(val).toLocaleString("ru-RU")} ₸`,
          },
        },
        legend: { position: "top" },
        tooltip: {
          y: {
            formatter: (val: number) => `${Math.round(val).toLocaleString("ru-RU")} ₸`,
          },
        },
      }}
    />
  );
}
